import React, { useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { setMembersList, setMembersMessage } from "redux/actions";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import { getMembers } from "services/membersService";
import Layout from "template";
import { Constant } from "template/Constant";
import { MembersForm } from "./form";
import { Vw_MembersTable } from "../vw_members/table";


export const Members: React.FC = () => {
  const dispatch = useAppDispatch();
  const rData = useSelector((state: RootState) => state.members);
  const [row, setRow] = useState(undefined);
  const [action, setAction] = useState('add');
  const getData = (page, pageSize, searchKey) => {
    getMembers(page, pageSize, searchKey).then((response) => {
      if (response && response.records) {
        dispatch(setMembersList({ pageNo: page, pageSize: pageSize, list: response.records, totalCount: response.totalCount, searchKey: searchKey }));
      } else {
		dispatch(setMembersMessage("No Record Found"));
      }
    })
  }

  const handleRowEdit = (rowData) => {
    setRow(rowData);
    dispatch(setMembersMessage(''));
    setAction('edit');
  }
  return (
    <Layout>
      <div className="container-fluid">
        {/* <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Members</h1>
        </div> */}
        <div className="d-flex flex-column min-vh-100">
        <MembersForm hideShowForm={setAction} action={action} row={row} getData={getData} />
          {/* {rData.message ?
            <Alert variant={Constant.defaultAlertVarient} className="alert-dismissible fade">{rData.message}
              <Button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => dispatch(setMembersMessage(''))}>
                <span aria-hidden="true">&times;</span>
              </Button>
            </Alert> : null} */}
          {/* {action =='edit' ? 
          <MembersForm hideShowForm={setAction} action={action} row={row} getData={getData} /> :
          <Vw_MembersTable handleRowEdit={handleRowEdit} hideShowForm={setAction} getData={getData} /> */}
            
            {/* } */}
        </div>

      </div>
    </Layout >
  );
};

